import { httpClient } from '@/api/http-client'
import { PartnerResume } from '@/types'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'

type Params = {
  companyKey: string
}

type ListPartnersResponse = Array<PartnerResume>

export const listPartners = async ({ companyKey }: Params) => {
  const response = await httpClient(
    'accounting-dealer',
  ).get<ListPartnersResponse>(`/v3/company/${companyKey}/partners`)
  return response.data
}

export const useListPartners = (
  { companyKey }: Params,
  options?: Partial<UseQueryOptions<ListPartnersResponse>>,
) => {
  return useQuery({
    queryKey: ['partners', companyKey],
    queryFn: () => listPartners({ companyKey }),
    ...options,
  })
}
